import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { type Cart } from '@hungryroot/rest';
import { patchBundleRequest } from '@hungryroot/rest/api/v2/customers/[id]/cart/bundles/[bundle_id]/patch';

interface Params
  extends UseMutationOptions<
    Cart,
    unknown,
    {
      bundleId: number;
      pairingId?: number;
      productId?: number;
    }
  > {}

export function usePatchBundleSelf(params: Params) {
  const { ...mutationOptions } = params;
  return useMutation({
    mutationFn: async (params: {
      bundleId: number;
      pairingId?: number;
      productId?: number;
    }) => {
      const res = await patchBundleRequest({
        ...params,
      });
      if (res.status !== 200) {
        throw res.data;
      }
      return res.data;
    },
    ...mutationOptions,
  });
}
